module.exports = {
    contentPath: '/erp'
};



// WEBPACK FOOTER //
// ./src/config/config.js